import { lazy } from "react";
import { ICreateEditGaiaObjectProps } from "./definitions";

const LazyCreateEditGaiaObject = lazy(() => import("./CreateEditGaiaObject"));

const CreateEditGaiaObject = (props: ICreateEditGaiaObjectProps) => (
  <LazyCreateEditGaiaObject {...props} />
);

export default CreateEditGaiaObject;
